var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTable',_vm._g(_vm._b({attrs:{"list":_vm.list,"selected":_vm.value,"headers":_vm.headersComputed,"actions":_vm.actions},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var header = ref.header;
var item = ref.item;
return [(_vm.hasAccessToGroups)?_c('router-link',{attrs:{"to":header.getRoute(item)},domProps:{"textContent":_vm._s(item.name)}}):_c('span',{domProps:{"textContent":_vm._s(item.name)}})]}},{key:"item.permissions",fn:function(ref){
var v = ref.value;
return [(v)?_c('BCollapser',{attrs:{"list":v,"min-height-by-count":2}}):_vm._e()]}},{key:"item.ates",fn:function(ref){
var v = ref.value;
return [(v)?_c('BCollapser',{attrs:{"list":v,"min-height-by-count":2}}):_vm._e()]}}])},'BTable',_vm.$attrs,false),_vm.$listeners || {}))}
var staticRenderFns = []

export { render, staticRenderFns }